function Footer() {
    return (
        <footer className='ml-[5%] pb-8'>
            <p>&copy; Jerome Orille 2024</p>
        </footer>
    );
}

export default Footer;
